<template>
    <div class="follow_content">
        <FollowPromptForm />
    </div>
</template>
<script>
import FollowPromptForm from './FollowPrompt/FollowPromptForm.vue';
export default {
    components: {
        FollowPromptForm
    }
}
</script>
<style scoped>
.follow_content{
    overflow: auto;
    height: calc(100% - 128px);
    width: 100%;
  padding: 62px 38px 38px 38px;
}
</style>
